// extracted by mini-css-extract-plugin
export default {"home":"style_home__5EYlP","header":"style_header__Ma1OV","title":"style_title__U5tSh"};